import { useResponsiveRender } from 'hooks/useResponsiveRender';
import { MenuExploreSchoolsApplication, MenuMatchesFavoritesTours } from './logged-menu';
import MobileMenu from './logged-mobileMenu/MobileMenu';
// styles
import styles from './logged-navigation.module.scss';

const LoggedNavigation = ({ routesNav, routesProfileMenu, openSettings, openResetPassword, fullname }) => {
  const { renderMobile } = useResponsiveRender({ breakpoint: 767 });
  const { renderMobile: renderWholeMenu } = useResponsiveRender({ breakpoint: 1024 });

  if (renderMobile) {
    return (
      <MobileMenu
        routesNav={routesNav}
        routesProfileMenu={routesProfileMenu}
        openSettings={openSettings}
        openResetPassword={openResetPassword}
        fullname={fullname}
      />
    );
  }

  const secondRoutes = routesNav.slice(2);

  return (
    <nav className={`${styles.logged_navigation} menu`} aria-labelledby="HeaderMenu">
      <div className={styles.nav}>
        <MenuExploreSchoolsApplication renderDrop={renderWholeMenu} routesNav={routesNav} />
        {!renderWholeMenu && <MenuMatchesFavoritesTours className={styles.more_menu} routesNav={secondRoutes} />}
      </div>
    </nav>
  );
};

export default LoggedNavigation;
